import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import {
  AccessPermissionService,
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { Helper, ProjectsFacade, abbreviateCountryStr } from '@piqet-angular/data';
import { Subject } from 'rxjs';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { NumericCellEditor } from 'libs/ui/src/lib/numeri-cell-editor/numeric-cell-editor.component';
import { cloneDeep } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class ProjectPackConversionDataGridService {
  projectPackConversionPayload: any;
  event: any;

  editConversionSuccess = new Subject<any>();
  editConversionSuccessData$ = this.editConversionSuccess.asObservable();

  copyPackConversion = new Subject<[any, any, any]>();
  copyPackConversionData$ = this.copyPackConversion.asObservable();

  deletePackConversion = new Subject<[any]>();
  deletePackConversionData$ = this.deletePackConversion.asObservable();

  constructor(
    private projectsFacade: ProjectsFacade,
    private swalService: SwalService,
    private accessService: AccessPermissionService
  ) {}

  accessPermission(): boolean {
    return this.accessService.hasPermission('edit', '', 'packaging');
  }

  getProjectPackConversionDataColumn(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'Name',
      headerName: 'Component details',
      field: 'name',
      suppressColumnsToolPanel: true,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      cellStyle: { 'text-decoration': 'underline', cursor: 'pointer' },
      resizable: false,
      autoHeaderHeight: true,
      lockPosition: true,
      wrapHeaderText: true,
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.style.cursor = 'pointer';
        cellElement.innerHTML = `${cellValue}`;
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          this.projectsFacade.openNewAddProjectMaterial(
            params.data.scenarioId,
            params.data.componentId,
            'Review material & conversion details',
            true,
            'conversion-list'
          );
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Transport',
      headerName: 'Transportation to converter',
      field: 'transport',
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'iconsOfTransport',
      resizable: false,
      autoHeight: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: true,
    });
    colDef.push({
      ...defaultColumn,
      colId: 'TotalDistance',
      headerName: 'Packaging movement (km)',
      field: 'totalDistance',
      cellClass: 'my-permission-cursor-pointer',
      resizable: false,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'ConversionProcessName',
      headerName: 'Conversion',
      field: 'conversionProcessName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      cellRenderer: (params: any) => {
        return `<div class="truncated-text" title="${params.value}">${
          params.value ? params.value : ''
        }</div>`;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'CountryName',
      headerName: 'Country',
      field: 'countryName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      valueFormatter: (params: any) => abbreviateCountryStr(params.data?.countryName),
    });
    colDef.push({
      ...defaultColumn,
      colId: 'SupplierName',
      headerName: 'Converter',
      field: 'supplierName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      cellRenderer: (params: any) => {
        return `<div class="truncated-text" title="${params.value}">${
          params.value ? params.value : ''
        }</div>`;
      },
      resizable: false,
    });

    this.accessPermission() &&
      colDef.push({
        ...defaultColumn,
        colId: 'Actions',
        headerName: 'Actions',
        field: 'Actions',
        sortable: false,
        maxWidth: grid_widths_map.sm_column_xs,
        suppressColumnsToolPanel: true,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'actionRenderer',
        cellRendererParams: {
          showEdit: true,
          showCopy: true,
          showDelete: true,
          deleteData: (data: any) => {
            this.deleteConfirmation(data);
          },
          editData: (data: any, pathName: any) => {
            this.projectsFacade.openNewAddProjectMaterial(
              data.scenarioId,
              data.componentId,
              'Review material & conversion details',
              false,
              pathName
            );
          },
          copyData: (data: any) => {
            const lable = 'Copy conversion';
            this.copyPackConversion.next([data, lable, data.scenarioId]);
          },
          copyDataEditRendarar: () => {
            return false;
          },
        },
        lockVisible: false,
        lockPosition: right,
        resizable: false,
      });
    return colDef;
  }
  getProjectPackConversionDataColumnForCost(): ColDef[] {
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'Name',
      headerName: 'Component details',
      field: 'name',
      suppressColumnsToolPanel: true,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      cellStyle: { 'text-decoration': 'underline', cursor: 'pointer' },
      lockVisible: false,
      resizable: false,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.style.cursor = 'pointer';
        cellElement.innerHTML = `${cellValue}`;
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          this.projectsFacade.openNewAddProjectMaterial(
            params.data.scenarioId,
            params.data.componentId,
            'Review material & conversion details',
            true,
            'conversion-list'
          );
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Transport',
      headerName: 'Transportation to converter',
      field: 'transport',
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'iconsOfTransport',
      lockVisible: false,
      resizable: false,
      autoHeight: true,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: true,
    });
    colDef.push({
      ...defaultColumn,
      colId: 'TotalDistance',
      headerName: 'Packaging movement (km)',
      field: 'totalDistance',
      cellClass: 'my-permission-cursor-pointer',
      lockVisible: false,
      resizable: false,
      lockPosition: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: true,
    });
    colDef.push({
      ...defaultColumn,
      colId: 'ConversionProcessName',
      headerName: 'Conversion',
      field: 'conversionProcessName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      resizable: false,
      wrapHeaderText: true,
      cellRenderer: (params: any) => {
        return `<div class="truncated-text" title="${params.value}">${
          params.value ? params.value : ''
        }</div>`;
      },
    });
    colDef.push({
      ...defaultColumn,
      colId: 'CountryName',
      headerName: 'Country',
      field: 'countryName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      wrapHeaderText: true,
      resizable: false,
      valueFormatter: (params: any) => abbreviateCountryStr(params.data?.countryName),
    });
    colDef.push({
      ...defaultColumn,
      colId: 'SupplierName',
      headerName: 'Converter',
      field: 'supplierName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: false,
      wrapHeaderText: true,
      resizable: false,
      cellRenderer: (params: any) => {
        return `<div class="truncated-text" title="${params.value}">${
          params.value ? params.value : ''
        }</div>`;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'ConversionCostS',
      headerName: 'Cost of conversion per kg',
      field: 'conversionCostS',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
      autoHeaderHeight: true,
      wrapHeaderText: true,
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'ConversionCostS') {
          return {
            component: NumericCellEditor,
          };
        }
        return undefined;
      },
      valueSetter: (params: any) => {
        const newValInt = params.newValue;
        const valueChanged = params.data.materialCost !== newValInt;
        params = cloneDeep(params);
        if (valueChanged) {
          params.data.materialCost =
            typeof params.oldValue == 'number' ? parseInt(newValInt) : newValInt;
        }
        return valueChanged;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'TotalConvesionCost',
      headerName: 'Cost of conversion',
      field: 'totalConvesionCost',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      autoHeaderHeight: true,
      wrapHeaderText: true,
      resizable: false,
    });

    this.accessPermission() &&
      colDef.push({
        ...defaultColumn,
        colId: 'Actions',
        headerName: 'Actions',
        field: 'Actions',
        sortable: false,
        maxWidth: grid_widths_map.sm_column_xs,
        suppressColumnsToolPanel: true,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'actionRenderer',
        cellRendererParams: {
          showEdit: true,
          showCopy: true,
          showDelete: true,
          deleteData: (data: any) => {
            this.deleteConfirmation(data);
          },
          editData: (data: any, pathName: any) => {
            this.projectsFacade.openNewAddProjectMaterial(
              data.scenarioId,
              data.componentId,
              'Review material & conversion details',
              false,
              pathName
            );
          },
          copyData: (data: any) => {
            const lable = 'Copy conversion';
            this.copyPackConversion.next([data, lable, data.scenarioId]);
          },
          copyDataEditRendarar: () => {
            return false;
          },
        },
        lockVisible: false,
        lockPosition: right,
        resizable: false,
      });
    return colDef;
  }

  getPackConversionProjectPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getProjectPackConversionDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.projectPackConversionPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'OrderId',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Asc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }

  getPackConversionList() {
    this.editConversionSuccess.next(() => {});
  }

  deleteConfirmation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deletePackConversion.next([data]);
      }
    });
  }
}
